import {Controller} from "react-hook-form";

// Import with CJS/ESM compatibility
import PhoneInputPkg from "react-phone-input-2";
import * as CountryRegionPkg from "react-country-region-selector";

// Handle CJS/ESM interoperability
const PhoneInput = (PhoneInputPkg as any)?.default || PhoneInputPkg;
const CountryDropdown = (CountryRegionPkg as any)?.CountryDropdown || CountryRegionPkg.CountryDropdown;
import {FormFieldProps} from "@/constants/type/props";


export default function FormField({
                                    name,
                                    control,
                                    label = "",
                                    type,
                                    className = "col-md-4",
                                    placeholder,
                                    options = [],
                                    rows = 5,
                                    required = false,
                                    disabled = false,
                                    inputClassName = "",
                                  }: FormFieldProps & {inputClassName?: string}) {

  const fieldId = name;

  const renderField = (onChange: any, value: any) => {
    switch (type) {
      case "text":
      case "email":
        return (
          <input
            type={type}
            className={`form-control ${inputClassName}`}
            id={fieldId}
            value={value || ""}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
          />
        );

      case "select":
        return (
          <select
            className={`form-control form-select select-container ${inputClassName}`}
            id={fieldId}
            value={value || ""}
            onChange={onChange}
            disabled={disabled}
          >
            <option value="">{placeholder || "Select..."}</option>
            {options.map((option) => (
              <option key={option.id} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        );

      case "textarea":
        return (
          <textarea
            rows={rows}
            className={`form-control ${inputClassName}`}
            id={fieldId}
            value={value || ""}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
          />
        );

      case "phone":
        return (
          <PhoneInput
            country={"us"}
            value={value}
            onChange={onChange}
            disabled={disabled}
            inputProps={{
              name: fieldId,
              id: fieldId,
              className: inputClassName,
            }}
          />
        );

      case "country":
        return (
          <CountryDropdown
            className={`form-control form-select select-container ${inputClassName}`}
            value={value}
            onChange={(val: string) => onChange(val)}
            defaultOptionLabel="Select a Country"
            disabled={disabled}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className={className}>
      {label && (
        <label htmlFor={fieldId} className="form-label">
          {label}
          {required && <span className="text-danger"> *</span>}
        </label>
      )}
      <Controller
        name={name}
        control={control}
        render={({field: {onChange, value}, fieldState: {error}}) => (
          <>
            {renderField(onChange, value)}
            <span className="fieldError">{error && error.message}</span>
          </>
        )}
      />
    </div>
  );
}
